import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { Trash2, Circle, Eye, EyeOff, Lock, Unlock } from 'lucide-react';


const ItemType = 'LAYER';

const LayerRow = ({
  item,
  index,
  moveLayer,
  onSelect,
  onDelete,
  onToggleVisibility,
  onToggleLock, // ADD THIS
  selectedItemId,
}) => {
  const ref = React.useRef(null);

  const [, drop] = useDrop({
    accept: ItemType,
    hover(draggedItem) {
      if (draggedItem.index === index || item.locked) return;
      moveLayer(draggedItem.index, index);
      draggedItem.index = index;
    },
  });

  const [, drag] = useDrag({
    type: ItemType,
    item: { id: item.id, index },
    canDrag: () => !item.locked,
  });

  drag(drop(ref));

  return (
 <div
      ref={ref}
      className={`flex items-center justify-between px-2 py-1 cursor-move ${
        selectedItemId === item.id ? 'bg-blue-100' : 'hover:bg-sky-100'
      } ${item.locked ? 'opacity-70' : ''}`}
      onClick={() => onSelect(item.id)}
    >
      <div className="flex items-center gap-2 overflow-hidden">
        {item.icon || <Circle size={14} className="text-gray-500" />}
        <span className="text-xs truncate max-w-[120px] text-gray-800">{item.label || item.id}</span>
      </div>
      <div className="flex gap-1">
        <button
          className="text-gray-500 hover:text-gray-700 p-1"
          onClick={(e) => {
            e.stopPropagation();
            onToggleLock(item.id);
          }}
          title={item.locked ? "Unlock" : "Lock"}
        >
          {item.locked ? <Lock size={14} /> : <Unlock size={14} />}
        </button>
        <button
          className="text-gray-500 hover:text-gray-700 p-1"
          onClick={(e) => {
            e.stopPropagation();
            onToggleVisibility(item.id);
          }}
          title={item.visible !== false ? "Hide" : "Show"}
        >
          {item.visible !== false ? <Eye size={14} /> : <EyeOff size={14} />}
        </button>
        <button
          className="text-gray-500 hover:text-red-500 p-1"
          onClick={(e) => {
            e.stopPropagation();
            if (!item.locked) {
              onDelete(item.id);
            }
          }}
          title="Delete"
          disabled={item.locked}
        >
          <Trash2 size={14} className={item.locked ? "opacity-50" : ""} />
        </button>
      </div>
    </div>
  );
};

export default function LayerPanelMainCanvas({
  canvasItems = [],
  onDelete,
  onSelect,
  onToggleVisibility,
  onToggleLock, // ADD THIS PROP
  onReorderLayers,
  selectedItemId,
}) {
  const moveLayer = (from, to) => {
    const updatedItems = [...canvasItems];
    const [moved] = updatedItems.splice(from, 1);
    updatedItems.splice(to, 0, moved);

    updatedItems.forEach((it, idx) => {
      it.zIndex = updatedItems.length - idx;
    });

    onReorderLayers(updatedItems);
  };

  return (
    <div className="w-auto bg-white">
      {canvasItems.map((item, index) => (
        <React.Fragment key={item.id}>
          <LayerRow
            item={item}
            index={index}
            moveLayer={moveLayer}
            onSelect={onSelect}
            onDelete={onDelete}
            onToggleVisibility={onToggleVisibility}
            onToggleLock={onToggleLock}
            selectedItemId={selectedItemId}
          />
          {/* Add divider line after each item except the last one */}
          {index < canvasItems.length - 1 && (
            <div className="border-t border-gray-200 mx-2"></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}